import React from 'react';
import { Eye, Edit2, MessageSquare } from 'lucide-react';
import { Task, TaskStatus, TaskPriority } from '../../../types/task';
import Badge from '../../../components/ui/Badge';
import { taskStatusVariant, taskPriorityVariant } from '../../../utils/badgeVariants';

export const TASK_COLUMNS = (
  onView: (id: number) => void,
  onEdit: (id: number) => void,
  onComments: (id: number) => void,
) => [
  {
    id: 'task_name',
    label: 'Item',
    accessor: 'task_name',
    render: (t: Task) => (
      <span style={{ fontSize: 13, color: 'var(--text-primary)' }}>{t.task_name}</span>
    ),
  },
  {
    id: 'task_number',
    label: 'Identifier',
    accessor: 'task_number',
    render: (t: Task) => (
      <span style={{ fontSize: 13, fontFamily: 'monospace', color: 'var(--text-secondary)' }}>{t.task_number}</span>
    ),
  },
  {
    id: 'status',
    label: 'Status',
    accessor: 'status',
    render: (t: Task) => (
      <Badge variant={taskStatusVariant(t.status)}>{t.status}</Badge>
    ),
  },
  {
    id: 'priority',
    label: 'Priority',
    accessor: 'priority',
    render: (t: Task) => (
      <Badge variant={taskPriorityVariant(t.priority)}>{t.priority}</Badge>
    ),
  },
  {
    id: 'assigned',
    label: 'Assigned',
    accessor: 'assigned',
    render: (t: Task) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>
        {t.assignee ? t.assignee.name : t.assignedTeam ? t.assignedTeam.name : '-'}
      </span>
    ),
  },
  {
    id: 'due_date',
    label: 'Due',
    accessor: 'due_date',
    render: (t: Task) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>
        {t.due_date ? new Date(t.due_date).toLocaleDateString() : '-'}
      </span>
    ),
  },
  {
    id: 'project',
    label: 'Project',
    accessor: 'project',
    render: (t: Task) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{t.project?.name || '-'}</span>
    ),
  },
  {
    id: 'updated_at',
    label: 'Last Update',
    accessor: 'updated_at',
    render: (t: Task) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>
        {new Date(t.updated_at).toLocaleString()}
      </span>
    ),
  },
  {
    id: 'actions',
    label: 'Actions',
    accessor: 'actions',
    render: (t: Task) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button
          onClick={(e) => { e.stopPropagation(); onView(t.id); }}
          title="View"
          style={{ padding: '6px', color: '#2563eb', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(37,99,235,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <Eye style={{ width: 14, height: 14 }} />
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); onEdit(t.id); }}
          title="Edit"
          style={{ padding: '6px', color: '#7c3aed', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(124,58,237,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <Edit2 style={{ width: 14, height: 14 }} />
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); onComments(t.id); }}
          title="Comments"
          style={{ padding: '6px', color: '#16a34a', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(22,163,74,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <MessageSquare style={{ width: 14, height: 14 }} />
        </button>
      </div>
    ),
  },
];
